export default "__VITE_ASSET__CIQYMJNy__"